import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const PagoTipo = {

    async Get() {  return await methods.Get("PagoTipo/Get" ); },
    async Post(data) { return await methods.Post("PagoTipo/Post", data) },
    async Put(qs, data) { return await methods.Put("PagoTipo/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("PagoTipo/Delete" + useParamsJson(qs)) }
};

export default PagoTipo;